module.exports = __webpack_public_path__ + "img/tag_mj.07dffeb7.png";